import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import Divider from '@mui/material/Divider'
import FormControl from '@mui/material/FormControl'
import Link from 'Components/Link'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiCard from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import AppTheme from '../shared-theme/AppTheme'
import settings from 'Settings'
import useUserStore from 'Store/userStore'
import useNavigateCustom from 'Components/Navigation'
import { useTranslation } from 'react-i18next'
import OauthSignIn from 'Pages/Auth/OauthSignIn'
import { useLocation } from 'react-router-dom'

function useQuery() {
      return new URLSearchParams(useLocation().search)
}

const Card = styled(MuiCard)(({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      alignSelf: 'center',
      width: '100%',
      // padding: theme.spacing(4),
      gap: theme.spacing(2),
      margin: 'auto',
      boxShadow:
            'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
      [theme.breakpoints.up('sm')]: {
            width: '450px',
      },
      ...theme.applyStyles('dark', {
            boxShadow:
                  'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
      }),
}))

const SignUpContainer = styled(Stack)(({ theme }) => ({
      width: '100%',
      // height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
      minHeight: '100%',
      padding: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4),
      },
      '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            zIndex: -1,
            inset: 0,
            backgroundImage:
                  'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
            backgroundRepeat: 'no-repeat',
            ...theme.applyStyles('dark', {
                  backgroundImage:
                        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
            }),
      },
}))

export default function SignUp(props: { disableCustomTheme?: boolean }) {
      const [emailError, setEmailError] = React.useState(false)
      const [emailErrorMessage, setEmailErrorMessage] = React.useState('')
      const [passwordError, setPasswordError] = React.useState(false)
      const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('')
      const [nameError, setNameError] = React.useState(false)
      const [nameErrorMessage, setNameErrorMessage] = React.useState('')
      const query = useQuery()
      const [loginName, setLoginName] = React.useState('')
      const registerGuest = useUserStore((state) => state.registerGuest)
      const login = useUserStore((state) => state.login)

      const { navigate } = useNavigateCustom()
      const { t } = useTranslation()

      // Fill name from query param when component mounts
      React.useEffect(() => {
            const username = query.get('username')
            if (username) {
                  setLoginName(username)
            }
      }, [query])
      // Fill name from query param when component mounts
      React.useEffect(() => {
            const username = query.get('username')
            if (username) {
                  setLoginName(username)
            }
      }, [query])

      const validateInputs = () => {
            // const email = document.getElementById('email') as HTMLInputElement
            // const password = document.getElementById('password') as HTMLInputElement
            const name = document.getElementById('name') as HTMLInputElement

            let isValid = true

            // if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
            //   setEmailError(true)
            //   setEmailErrorMessage(t('register_error_try_another_email'))
            //   isValid = false
            // } else {
            //   setEmailError(false)
            //   setEmailErrorMessage('')
            // }

            // if (!password.value || password.value.length < 6) {
            //   setPasswordError(true)
            //   setPasswordErrorMessage(t('register_error_try_another_password'))
            //   isValid = false
            // } else {
            //   setPasswordError(false)
            //   setPasswordErrorMessage('')
            // }

            if (!name.value || name.value.length < 1) {
                  setNameError(true)
                  setNameErrorMessage(t('register_error_try_another_name'))
                  isValid = false
            } else {
                  setNameError(false)
                  setNameErrorMessage('')
            }

            return isValid
      }

      const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault()
            if (nameError) {
                  event.preventDefault()
                  return
            }
            const data = new FormData(event.currentTarget)
            const registerData = {
                  name: data.get('name')?.toString() || '',
                  email: data.get('email')?.toString() || '',
                  password: data.get('password')?.toString() || '',
            }
            let response = null
            if (loginName.length) {
                  response = await login({ email: loginName, password: '123456q!' })
            } else {
                  response = await registerGuest(registerData.name)
            }
            if (response) {
                  navigate('/dashboard')
            } else {
                  setEmailError(true)
                  setEmailErrorMessage('An error occured. Please try again.')
            }
      }

      return (
            <AppTheme {...props}>
                  <CssBaseline enableColorScheme />
                  {/* <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} /> */}
                  <SignUpContainer direction="column" justifyContent="space-between">
                        <Card variant="outlined" sx={{ background: 'rgb(255 255 255 / 50%)' }}>
                              {/* <Typography
                                    component="h1"
                                    variant="h4"
                                    sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
                              >
                                    {t('register_register')}
                              </Typography> */}
                              <Box
                                    component="form"
                                    onSubmit={handleSubmit}
                                    sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
                              >
                                    {settings.useSSO ? (
                                          <>
                                                <Box
                                                      sx={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 2,
                                                      }}
                                                >
                                                      <OauthSignIn />
                                                      {/* <Typography sx={{ textAlign: 'center' }}>
                    {t('register_have_account')}
                    <Link href="signin" variant="body2" sx={{ alignSelf: 'center' }}>
                      {t('register_login_here')}
                    </Link>
                  </Typography> */}
                                                </Box>
                                                <Divider>
                                                      <Typography sx={{ color: 'text.secondary' }}>
                                                            {t('login_or')}
                                                      </Typography>
                                                </Divider>
                                          </>
                                    ) : null}
                                    <FormControl>
                                          {!(loginName.length > 0) && (
                                                <TextField
                                                      autoComplete="name"
                                                      name="name"
                                                      required
                                                      fullWidth
                                                      id="name"
                                                      placeholder={t('register_name')}
                                                      error={nameError}
                                                      helperText={nameErrorMessage}
                                                      color={nameError ? 'error' : 'primary'}
                                                />
                                          )}
                                    </FormControl>
                                    {/* <FormControl>
              <FormLabel htmlFor="email">{t('register_email')}</FormLabel>
              <TextField
                required
                fullWidth
                id="email"
                placeholder={t('register_email')}
                name="email"
                autoComplete="email"
                variant="outlined"
                error={emailError}
                helperText={emailErrorMessage}
                color={passwordError ? 'error' : 'primary'}
              />
            </FormControl>
            <FormControl>
              <FormLabel htmlFor="password">{t('register_password')}</FormLabel>
              <TextField
                required
                fullWidth
                name="password"
                placeholder="••••••"
                type="password"
                id="password"
                autoComplete="new-password"
                variant="outlined"
                error={passwordError}
                helperText={passwordErrorMessage}
                color={passwordError ? 'error' : 'primary'}
              />
            </FormControl> */}
                                    <Button
                                          type="submit"
                                          fullWidth
                                          variant="contained"
                                          onClick={validateInputs}
                                    >
                                          {loginName.length > 0 ? 'Demo' : t('register_register')}
                                    </Button>
                              </Box>
                        </Card>
                  </SignUpContainer>
            </AppTheme>
      )
}
